export default "./images/EN55.jpg";